// src/components/Login.js
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
  Box,
  Button,
  Checkbox,
  Divider,
  FormLabel,
  FormControl,
  FormControlLabel,
  Link,
  TextField,
  Typography,
} from "@mui/material";

import { useDispatch } from "react-redux";

import { GoogleIcon, FacebookIcon } from "../../constant/CustomIcon";
import ForgotPassword from "../forgetPassword/ForgotPassword";
import CustomCard from "../../components/cards/CustomCard";

import { validateLoginFields } from "../../utils/validation/validation";
import { loginRequest } from "../../services/api/auth";
import { SUCCESS_MESSAGES } from "../../constant/messages";
import { showToast } from "../../store/slices/toastSlice";
import { login } from "../../store/slices/authSlice";

export const Login = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [credentials, setCredentials] = useState({
    email: "",
    password: "",
  });

  useEffect(() => {
    const registerSuccess = localStorage.getItem("registerSuccess");
    const logoutSuccess = localStorage.getItem("logoutSuccess");

    if (registerSuccess) {
      dispatch(
        showToast({
          message: SUCCESS_MESSAGES.USER_REGISTERED_SUCCESSFULLY,
          severity: "success",
        })
      );
      localStorage.removeItem("registerSuccess");
    }

    if (logoutSuccess) {
      dispatch(showToast({ message: logoutSuccess, severity: "success" }));
      localStorage.removeItem("logoutSuccess");
    }
  }, [dispatch]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setCredentials((prev) => ({ ...prev, [name]: value }));
  };

  const handleLogin = async (e) => {
    e.preventDefault();

    const validationResult = validateLoginFields(credentials);
    if (!validationResult.valid) {
      dispatch(
        showToast({ message: validationResult.message, severity: "error" })
      );
      return;
    }

    try {
      const data = await loginRequest(credentials);

      if (data.responseCode === 200) {
        localStorage.setItem("token", data.token);
        dispatch(login(data.token));
        dispatch(showToast({ message: data.message, severity: "success" }));
        navigate("/dashboard");
      }
    } catch (error) {
      dispatch(showToast({ message: error.message, severity: "error" }));
    }
  };

  const handleSocialLogin = (platform) => {
    alert(`Sign in with ${platform}`);
  };

  return (
    <CustomCard topMargin={100}>
      <Typography
        component="h1"
        variant="h4"
        sx={{ width: "100%", fontSize: "clamp(2rem, 10vw, 2.15rem)" }}
      >
        Sign in
      </Typography>
      <Box
        component="form"
        onSubmit={handleLogin}
        noValidate
        sx={{ display: "flex", flexDirection: "column", width: "100%", gap: 2 }}
      >
        <FormControl>
          <FormLabel htmlFor="email">Email</FormLabel>
          <TextField
            id="email"
            name="email"
            placeholder="Email or Username"
            required
            fullWidth
            variant="outlined"
            value={credentials.email}
            onChange={handleChange}
            autoComplete="true"
          />
        </FormControl>

        <FormControl>
          <Box sx={{ display: "flex", justifyContent: "space-between" }}>
            <FormLabel htmlFor="password">Password</FormLabel>
            <Link
              component="button"
              onClick={() => console.log("Password reset")}
              variant="body2"
              sx={{ alignSelf: "baseline", color: "black" }}
            >
              Forgot your password?
            </Link>
          </Box>
          <TextField
            id="password"
            name="password"
            placeholder="••••••"
            type="password"
            required
            fullWidth
            variant="outlined"
            value={credentials.password}
            onChange={handleChange}
          />
        </FormControl>

        <FormControlLabel
          id="remember_me"
          control={<Checkbox value="remember" color="primary" />}
          label="Remember me"
        />

        <ForgotPassword open={false} handleClose={() => {}} />

        <Button
          type="submit"
          fullWidth
          variant="contained"
          sx={{ backgroundColor: "black" }}
        >
          Sign in
        </Button>

        <Typography sx={{ textAlign: "center" }}>
          Don&apos;t have an account?{" "}
          <Link href="/register" variant="body2">
            Sign up
          </Link>
        </Typography>
      </Box>

      <Divider>or</Divider>

      <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
        <Button
          type="button"
          fullWidth
          variant="outlined"
          onClick={() => handleSocialLogin("Google")}
          startIcon={<GoogleIcon />}
        >
          Sign in with Google
        </Button>

        <Button
          type="button"
          fullWidth
          variant="outlined"
          onClick={() => handleSocialLogin("Facebook")}
          startIcon={<FacebookIcon />}
        >
          Sign in with Facebook
        </Button>
      </Box>
    </CustomCard>
  );
};
